import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";
import { isAnnual } from "@/react/helpers/planHelpers";

import { usePlans } from "../../../RegularPlan/PlansContext";

export const PlanTitle = () => {
  const { selectedPlan } = usePlans();
  if (!selectedPlan) return null;

  return (
    <div className="flex justify-between">
      <Typography.LabelSm weight="semibold">
        {t("pricing_plans.plan_settings.plan_summary.plan_name", {
          plan: selectedPlan.display_name,
        })}
      </Typography.LabelSm>
      <Typography.LabelSm weight="semibold">
        {isAnnual(selectedPlan.interval) ? (
          <Typography.LabelSm weight="semibold">
            {selectedPlan.annual_base_amount_with_currency}
          </Typography.LabelSm>
        ) : (
          <Typography.LabelSm weight="semibold">
            {selectedPlan.display_base_monthly_amount}
          </Typography.LabelSm>
        )}
      </Typography.LabelSm>
    </div>
  );
};
